import { type Country, type Language } from '~/common/enums';
import createRestClient from '../restClient';
import { objectToFormData } from '@/shared/utils/helpers';

const client = createRestClient();

export type AddMandateRequest = {
  crmId: string;
  hoaId: string;
  firstName: string;
  lastName: string;
  companyName?: string | null;
  vatNumber?: string | null;
  emailAddress: string;
  language: Language;
  iban: string;
  streetNumber: string;
  streetName: string;
  city: string;
  postalCode: string;
  country: Country;
};

const addManualMandate = (data: AddMandateRequest) =>
  client.post('/finance/direct-debit/mandate', objectToFormData(data), {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export type UpsertDirectDebitSettingsRequest = {
  hoaId: string;
  isEnabled: boolean;
  sendPushNotifications: boolean;
  collectionDelayDays: number;
  idBackFront?: File | null;
  idBack?: File | null;
  idFront?: File | null;
  proxyDocument?: File | null;
  contactPerson?: {
    city?: string;
    country?: Country;
    firstName?: string;
    lastName?: string;
    postalCode?: string;
    streetName?: string;
    streetNumber?: string;
    dateOfBirth?: string;
    nationality?: Country;
    placeOfBirth?: string;
  };
};

const upsertDirectDebitSettings = (data: UpsertDirectDebitSettingsRequest) =>
  client.put('/finance/homeownerAssociation/direct-debit', objectToFormData(data), {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export default {
  addManualMandate,
  upsertDirectDebitSettings,
};
